<script lang="ts">
	import type { Zoi } from './types';
	import defaultPoiImage from '$assets/pois/default.webp';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import Image from '$lib/components/atoms/image/Image.svelte';
	import * as m from '$paraglide/messages';

	export let images: Zoi['images'];
	export let onclick: () => void;
</script>

<div class="p-2 rd-4 shadow-smooth-bottom-1 flex gap-4 w-full items-center bg-neutral-weakest">
	<Image
		src={images ? images.w320 : defaultPoiImage}
		alt=""
		class="w-20 h-20 object-cover rd-2 shadow-smooth-bottom-3"
	/>
	<div class="flex flex-col justify-between gap-2 flex-1">
		<div class="text-md">{m.zoi_card__arrival__available_accommodation()}</div>
		<Button
			text={m.zoi_card__arrival__see_accommodation_zone()}
			icon="zoom-in"
			color="light"
			class="w-fit"
			{onclick}
		/>
	</div>
</div>
